var toggleMixin = {
	methods: {
		slideUp: function (target, duration = 500) {
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.boxSizing = 'border-box';
			target.style.height = target.offsetHeight + 'px';
			target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			window.setTimeout(() => {
				target.style.display = 'none';
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
				//alert("!");
			}, duration);
		},
		slideDown: function (target, duration = 500) {
			target.style.removeProperty('display');
			let display = window.getComputedStyle(target).display;
			if (display === 'none') display = 'block';
			target.style.display = display;
			let height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			window.setTimeout(() => {
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		},
		/**
		 * Toggles a div. Event passed in and target retrieved from data attribute called toggle
		 * @param {any} event
		 * @param {any} duration
		 */
		slideToggle: function (event, duration = 500) {
			const vm = this;
			const id = event.target.dataset.toggle;
			const target = document.getElementById(id);

			if (window.getComputedStyle(target).display === 'none') {
				return vm.slideDown(target, duration);
			} else {
				return vm.slideUp(target, duration);
			}
		},
		slideToggleByElement: function (element, duration = 500) {
			const vm = this;
			const target = document.querySelector(element);

			if (window.getComputedStyle(target).display === 'none') {
				return vm.slideDown(target, duration);
			} else {
				return vm.slideUp(target, duration);
			}
		},
		toggleToolTip: function (target, duration = 500) {
			const vm = this;
			if (window.getComputedStyle(target).display === 'none') {
				return vm.slideDown(target, duration);
			} else {
				return vm.slideUp(target, duration);
			}
		},
		triggerToggle: function (event) {
			const vm = this;
			let id;
			id = event.target.dataset.toggle;
			const target = document.getElementById(id);

			vm.toggleToolTipIcon(id);
			vm.toggleToolTip(target);
		},
		/**
		 * Toggles the optional extras on a product
		 * @param {any} event
		 */
		slideOptionalExtraPanel: function (event) {
			const vm = this;

			const el = event.target.closest('div');
			const yesButton = el.querySelector('.trigger-show').classList;
			const noButton = el.querySelector('.trigger-hide').classList;
			const id = event.target.dataset.toggle;
			const target = document.getElementById(id);
			const thisButton = event.target.classList;

			if (thisButton.contains('trigger-hide')) {
				// console.log('no button clicked')
				yesButton.remove('btn-green');
				yesButton.add('btn-secondary');
				noButton.remove('btn-secondary');
				noButton.add('btn-green');
				vm.slideUp(target, 200);
				vm.clearOptionalExtras(id);
			} else {
				// console.log('yes button clicked');
				yesButton.remove('btn-secondary');
				yesButton.add('btn-green');
				noButton.add('btn-secondary');
				noButton.remove('btn-green');
				vm.slideDown(target, 200);
				vm.openOptionalExtras(id);
			}
		},
		/**
		 * Close the tooltip and toggles the icon. Called from the 'x'.
		 * @param {any} event
		 * @param {any} attr
		 */
		closeToolTip: function (event, attr = 'toggle') {
			const id = event.target.closest('div.' + attr).id;
			const toolTipToToggle = document.getElementById(id);
			this.toggleToolTipIcon(id);
			this.toggleToolTip(toolTipToToggle);
		},
		/**
		 * Toggles the tooltip icon between green and filled and not filled.
		 * @param {any} id
		 */
		toggleToolTipIcon: function (id) {
			const vm = this;
			const toolTipToToggle = document.getElementById(id);
			var icons = document.querySelector("[data-toggle='" + id + "']");

			icons.classList.toggle('fc-green');
			icons.classList.toggle('tooltip-active');
			if (icons.querySelector('svg').length < 1) {
				icons.innerText = icons.classList.contains('fc-green') ? 'info' : 'info_outline';
			}
		},
	},
};
